<script setup>
import { CdrText } from '@rei/cedar';
import DepartureInfo from './DepartureInfo.vue';
import CancellationRefundPolicy from './CancellationRefundPolicy.vue';
import ReservationDisplay from './ReservationDisplay.vue';
import StepNavigation from './StepNavigation.vue';
import { useCancellationStore } from '../../stores/day-cancellation';
import cms from './data';

const cancellation = useCancellationStore();

const primary = () => {
  if (typeof window !== 'undefined') {
    window.location.replace('https://www.rei.com/events');
  }
};

const secondary = () => {
  cancellation.reset();
};
</script>

<template>
  <section class="cancelled-registration">
    <CdrText
      class="cancelled-registration__title"
      tag="h1"
    >
      {{ cms.cancelledReservation.title }}
    </CdrText>
    <CdrText
      class="cancelled-registration__sub-title"
      tag="h2"
    >
      {{ cms.cancelledReservation.subTitle }}
    </CdrText>
    <CdrText
      class="cancelled-registration__cancel-heading"
      tag="h3"
    >
      {{ cms.cancelledReservation.subTitle }}
    </CdrText>
    <DepartureInfo class="cancelled-registration__departure-info" />
    <CdrText class="cancelled-registration__for">for</CdrText>
    <ReservationDisplay
      class="cancelled-registration__reservation-display"
      :reservations="cancellation.reservations.items"
    />
    <StepNavigation
      class="cancelled-registration__step-navigation"
      :primary="cms.cancelledReservation.navigation.primary"
      :secondary="cms.cancelledReservation.navigation.secondary"
      @primary="primary"
      @secondary="secondary"
    />
    <CancellationRefundPolicy />
  </section>
</template>

<style lang="scss" scoped>
@import '@rei/cdr-tokens/dist/rei-dot-com/scss/cdr-tokens.scss';

.cancelled-registration {
  max-width: 587px;
  padding-top: $cdr-space-one-x;

  &__title {
    @include cdr-text-heading-serif-900;
  }

  &__sub-title {
    @include cdr-text-heading-serif-500;
    padding-top: $cdr-space-one-x;
  }

  &__cancel-heading,
  &__for {
    @include cdr-text-body-300;
    padding-top: $cdr-space-two-x;
  }

  &__departure-info {
    padding-top: $cdr-space-one-x;
  }

  &__reservation-display {
    padding-top: $cdr-space-half-x;
  }

  &__step-navigation {
    padding-top: $cdr-space-two-x;
  }
}
</style>
